<div class="container">
  <div class="container mt-5 text-center">
    <h3  class="display-5 fw-light" style="color: var(--secondary-color);">¿Por qué es <span class="fw-bold"> importante?</span></h3>
  </div>
  <div class="container w-75 mx-auto text-start">
    <ul style="list-style: none;">
      <li *ngFor="let listItem of listItems" class="mt-3 text-secondary">
        <i style="color: var(--terciary-color); font-size: .7rem" class="bi bi-circle-fill"></i>
        {{ listItem.texto }}
      </li>
    </ul>
  </div>
</div>
